module.exports = __webpack_public_path__ + "img/face_love_blue.631e1464.svg";